/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/countries';
import '../../onboard/business/categories';
import '../../onboard/business/subcategories';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "common": {
                "nested": {
                  "MerchantAnalytic": {
                    "fields": {
                      "name": {
                        "type": ".squareup.onboarding.business.common.MerchantAnalytic.Name",
                        "id": 1,
                        "rule": "optional"
                      },
                      "value": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Name": {
                        "values": {
                          "UNKNOWN": 1,
                          "ESTIMATED_REVENUE": 2,
                          "ESTIMATED_USAGE": 3,
                          "ESTIMATED_EMPLOYEE_COUNT": 4,
                          "PAYMENT_LOCATION": 5,
                          "PAYMENT_TYPE": 6,
                          "FEATURE": 7,
                          "ESTIMATED_MONTHLY_REVENUE": 8
                        }
                      }
                    }
                  },
                  "Vat": {
                    "fields": {
                      "number": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "address": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetMerchantCategoriesResponse": {
                    "fields": {
                      "category": {
                        "type": ".squareup.onboard.business.categories.BusinessCategory",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subcategory": {
                        "type": ".squareup.onboard.business.subcategories.BusinessSubcategory",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessSize": {
                    "values": {
                      "BUSINESS_SIZE_UNKNOWN": 0,
                      "BUSINESS_SIZE_JUST_ME": 1,
                      "BUSINESS_SIZE_1_TO_10_EMPLOYEES": 2,
                      "BUSINESS_SIZE_11_TO_50_EMPLOYEES": 3,
                      "BUSINESS_SIZE_51_TO_100_EMPLOYEES": 4,
                      "BUSINESS_SIZE_MORE_THAN_100_EMPLOYEES": 5
                    }
                  },
                  "EstimatedAnnualRevenue": {
                    "values": {
                      "ESTIMATED_ANNUAL_REVENUE_UNKNOWN": 0,
                      "ESTIMATED_ANNUAL_REVENUE_UNDER_50K": 1,
                      "ESTIMATED_ANNUAL_REVENUE_50K_TO_100K": 2,
                      "ESTIMATED_ANNUAL_REVENUE_100K_TO_250K": 3,
                      "ESTIMATED_ANNUAL_REVENUE_OVER_250K": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.common?.nested?.MerchantAnalytic && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.common?.nested?.MerchantAnalytic?.nested?.Name && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.common?.nested?.Vat && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.common?.nested?.GetMerchantCategoriesResponse && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.common?.nested?.BusinessSize && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.common?.nested?.EstimatedAnnualRevenue) {
  $root.addJSON(jsonData);
}

/**
 * Information about the Merchant's business collected during the onboarding process.
 *
 * SOURCE MerchantAnalytic @ squareup/onboarding/business/common.proto at 13:1
 */
export const MerchantAnalytic = $root.lookupType('squareup.onboarding.business.common.MerchantAnalytic');
fixType(MerchantAnalytic);
Builder.createAndAttachToType(MerchantAnalytic);
/**
 * SOURCE Name @ squareup/onboarding/business/common.proto at 17:3
 */
MerchantAnalytic.Name = $root.lookupEnum('squareup.onboarding.business.common.MerchantAnalytic.Name').values;
/**
 * SOURCE Vat @ squareup/onboarding/business/common.proto at 29:1
 */
export const Vat = $root.lookupType('squareup.onboarding.business.common.Vat');
fixType(Vat);
Builder.createAndAttachToType(Vat);
/**
 * SOURCE GetMerchantCategoriesResponse @ squareup/onboarding/business/common.proto at 36:1
 */
export const GetMerchantCategoriesResponse = $root.lookupType('squareup.onboarding.business.common.GetMerchantCategoriesResponse');
fixType(GetMerchantCategoriesResponse);
Builder.createAndAttachToType(GetMerchantCategoriesResponse);
/**
 * source: https://github.com/squareup/onboard-frontend/blob/4936a19b7bb78f0a5b4feb350e2ef3c77153a9d1/next-js/src/components/steps/business-information/EmployeeCount.tsx#L25
 *
 * SOURCE BusinessSize @ squareup/onboarding/business/common.proto at 42:1
 */
export const BusinessSize = $root.lookupEnum('squareup.onboarding.business.common.BusinessSize').values;
/**
 * source: https://github.com/squareup/onboard-frontend/blob/4936a19b7bb78f0a5b4feb350e2ef3c77153a9d1/next-js/src/components/steps/business-information/EstimatedAnnualRevenue.tsx#L11
 *
 * SOURCE EstimatedAnnualRevenue @ squareup/onboarding/business/common.proto at 52:1
 */
export const EstimatedAnnualRevenue = $root.lookupEnum('squareup.onboarding.business.common.EstimatedAnnualRevenue').values;